import { render } from "./RatingComponent.vue?vue&type=template&id=3dff273a&scoped=true"
import script from "./RatingComponent.vue?vue&type=script&lang=js"
export * from "./RatingComponent.vue?vue&type=script&lang=js"

import "./RatingComponent.vue?vue&type=style&index=0&id=3dff273a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dff273a"]])

export default __exports__